import { motion } from "framer-motion";
import { CUSTOMER_PROBLEMS } from "@/data/content";

const PROBLEM_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/4fm6kwhq_cabd5886-5f65-4177-bd17-7c89fdfdbb40.png";

const Row = ({ item, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.4 }}
    transition={{ duration: 0.5, delay: index * 0.06 }}
    data-testid={`customer-problem-item-${item.n}`}
    className={
      index === CUSTOMER_PROBLEMS.length - 1
        ? "pt-6 pb-6 lg:pb-0 border-t border-borderLight"
        : "py-6 border-t border-borderLight"
    }
  >
    <div className="flex gap-5">
      <span className="font-mono text-sm text-teal shrink-0 pt-0.5">{item.n}</span>
      <div>
        <h3 className="font-heading text-lg font-semibold text-ink">{item.title}</h3>
        <p className="text-inkSoft leading-relaxed mt-2 text-[15px]">
          {item.n === "02" ? (
            <>
              Backup generators bring recurring fuel, delivery, maintenance, noise
              <br className="hidden lg:block" /> and operating requirements.
            </>
          ) : (
            item.body
          )}
        </p>
      </div>
    </div>
  </motion.div>
);

export const CustomerProblem = () => (
  <section data-testid="customer-problem-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:max-w-[1280px] lg:mx-auto">
      <div className="grid grid-cols-1 gap-[14px] sm:gap-12 lg:grid-cols-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-6"
        >
          <h2 className="font-heading text-[30px] sm:text-[35px] lg:text-[41px] font-semibold text-ink leading-[1.12]">
            Farm energy was never designed to be simple
          </h2>

          <div className="mt-10">
            <div className="border-t border-borderLight" />
            {CUSTOMER_PROBLEMS.map((item, i) => (
              <Row key={item.n} item={item} index={i} />
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="relative lg:col-span-6"
        >
          <div className="relative h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:sticky lg:top-32 lg:h-[374px]">
            <img
              src={PROBLEM_IMAGE}
              alt="Dairy barn interior on a British Columbia farm"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
